import { useTranslations } from '@vocab/react';
import { Button, Inline } from 'braid-design-system';
import React from 'react';

import samlAuthorize from '../../../../../../modules/Auth0/samlAuthorize';
import { useLoginPageContext } from '../../../LoginPageContext';

import translations from './.vocab';

const SingleSignOnButton = () => {
  const { t } = useTranslations(translations);
  const { emailLookupResult, realmHint: initialRealmHint } =
    useLoginPageContext();
  const realmHint = emailLookupResult?.realmHint ?? initialRealmHint;

  return realmHint ? (
    <Inline space="none">
      <Button
        variant="transparent"
        onClick={() => {
          samlAuthorize({ connection: realmHint });
        }}
      >
        {t('Sign in with your identity provider')}
      </Button>
    </Inline>
  ) : null;
};

export default SingleSignOnButton;
